import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <label htmlFor="lang-select" className="sr-only">
        {t("language.label")}
      </label>
      <select
        id="lang-select"
        value={i18n.resolvedLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        className="form-control form-control-sm"
        style={{ width: "auto", display: "inline-block" }}
      >
        <option value="en">{t("language.en")}</option>
        <option value="vi">{t("language.vi")}</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
